import "UI/Template"
import "UI/Element"
import "UI/Util/FullScreen"
import "./Base"

/** @namespace GIS.Map.Control */
NS("GIS.Map.Control")

/**
 * @class
 * @extends GIS.Map.Control.Base
 */
GIS.Map.Control.FullScreen = Class(GIS.Map.Control.Base, /** @lends GIS.Map.Control.FullScreen.prototype */ {
    /**
     * @type {$.<HTMLElement>}
     */
    $control: null,
    template: "GIS/Control/FullScreen",
    keys: false,
    /**
     * @type {HTMLElement} Element that should be stretched
     */
    container: null,
    /** @inheritDoc */
    initialize () {
        this.ParentCall()
        this.render()
    },
    /**
     * @returns {GIS.Map.Control.FullScreen}
     */
    render () {
        this.$control = UI.Template.$render(this.template, {
            control: this
        })
        this.$control.appendTo(this.target || this.map.element)

        UI.Element.initEvent("click", "on-click", this.$control, this)

        return this
    },
    /**
     * @returns {GIS.Map.Control.FullScreen}
     */
    destroy () {
        this.container = null

        return this.ParentCall()
    },
    /**
     * @protected
     */
    onFullScreenClick () {
        if (!UI.Util.FullScreen.isSupported()) {
            return
        }

        if (UI.Util.FullScreen.isFullScreen()) {
            UI.Util.FullScreen.exitFullscreen()
        } else {
            const target = this.container || this.map.element

            if (this.keys) {
                UI.Util.FullScreen.requestFullScreenWithKeys(target)
            } else {
                UI.Util.FullScreen.requestFullScreen(target)
            }

            this.map.align()
        }
    }
})
